import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ClassificationType, ReferenceBookType, TransactionType, TypologyApiService} from '@npck/af-frontend-api';
import {DATE_SERVER_FORMAT} from '@npck/libs/commons';
import {combineLatest} from 'rxjs';
import {getFormattedDateOrNull} from '../../../../components/full-table/filter/filter.component';
import {DictionaryHolderService} from '../../../../domain/dictionary-holder.service';
import {CommonDashboardFilterValue} from '../../incident-fraud-dashboards/dashboard-filter/dashboard-filter.component';
import {ClassificationGroupPanelViewModel} from './classification-group-panel/classification-group-panel.component';
import {ClassificationPanelViewModel} from './classification-group-panel/classification-panel/classification-panel.component';

@Component({
    selector: 'af-classification-matrix',
    standalone: false,
    templateUrl: './classification-matrix.component.html',
})
export class ClassificationMatrixComponent {
    @Input() classificationBy: ClassificationType;
    @Input() transactionType: string;
    @Input() hasChips: boolean;
    @Output() openDetails = new EventEmitter<ClassificationPanelViewModel>();
    @Output() selectTypeListener = new EventEmitter<ClassificationType>();
    ClassificationType = ClassificationType;

    classificationGroupPanelData: ClassificationGroupPanelViewModel[] = [];
    selectedClassification: ClassificationType;
    hasMlLabel = false;

    constructor(
        private dictionaryHolderService: DictionaryHolderService,
        private typologyApiService: TypologyApiService,
    ) {
    }

    filter($event: CommonDashboardFilterValue): void {
        this.selectedClassification = this.classificationBy ?? $event.classificationBy;
        this.selectTypeListener.emit(this.selectedClassification);
        this.hasMlLabel = ClassificationType.FRAUD_TYPE === this.selectedClassification;
        combineLatest([
            this.dictionaryHolderService.getReference(ReferenceBookType.FRAUD_TYPE),
            this.dictionaryHolderService.getReference(ReferenceBookType.TRANSACTION_CATEGORY),
            this.dictionaryHolderService.getReference(ReferenceBookType.TRANSACTION_TYPE),
            this.typologyApiService.getClassificationGroup({
                startDate: getFormattedDateOrNull(new Date($event.dateRange.dateFrom), DATE_SERVER_FORMAT),
                endDate: getFormattedDateOrNull(new Date($event.dateRange.dateTo), DATE_SERVER_FORMAT),
                classificationType: this.selectedClassification,
                transactionType: this.transactionType as TransactionType,
            })])
            .subscribe(([frauds, transactionCategories, transactionTypes, response]) => {
                if (ClassificationType.FRAUD_TYPE === this.selectedClassification) {
                    this.classificationGroupPanelData = [<ClassificationGroupPanelViewModel>{
                        groupName: '',
                        items: frauds.filter(item => item.code1 === 'FRAUD')
                            .map(item => {
                                const count = response[0].items.find(responseItem => {
                                    return item.code === responseItem.type;
                                })?.count ?? 0;
                                return <ClassificationPanelViewModel>{
                                    count: count,
                                    dictionaryItem: item,
                                };
                            })
                            .sort((a, b) => {
                                const sumA = a.count ?? 0;
                                const sumB = b.count ?? 0;
                                return sumB - sumA;
                            }),
                    }];
                }
                if (this.selectedClassification === ClassificationType.TRANSACTION_TYPE) {
                    this.classificationGroupPanelData = transactionCategories.map((category) => {
                        const responseGroupItems = response.find(group => group.category === category.code)?.items;
                        return {
                            groupName: category.name_ru,
                            groupCode: category.code,
                            items: transactionTypes.filter(item => item.code1 === category.code)
                                .map(item => {
                                    const count = responseGroupItems?.find(responseItem => responseItem.type === item.code).count;
                                    return {
                                        dictionaryItem: item,
                                        count: count,
                                    };
                                })
                                .sort((a, b) => {
                                    const sumA = a.count ?? 0;
                                    const sumB = b.count ?? 0;
                                    return sumB - sumA;
                                }),
                        };
                    });
                }
            });
    }
}
